import { createContext, useContext } from "react";
import { Location } from "react-router";

export const LastLocationContext = createContext<Location | null>(null);

export const useLastLocation = () => useContext(LastLocationContext);
